
const colorMapping = {
  mtTemp1: [
    { min: -20, max: -10, color: 'rgb(174, 115, 187)' },
    { min: -10, max: 0, color: '#bba0c2ff' },
    { min: 0, max: 10, color: '#c2cfebff' },
    { min: 10, max: 20, color: '#21b7c2ff' },
    { min: 20, max: 30, color: '#4890d3ff' },
    { min: 30, max: 40, color: '#1935b4ff' },
    { min: 40, max: 50, color: '#1fa77eff' },
    { min: 50, max: 60, color: '#4f8f3bff' },
    { min: 60, max: 70, color: '#ffe25eff' },
    { min: 70, max: 80, color: 'rgb(255, 167, 94)' },
    { min: 80, max: 90, color: 'rgb(247, 72, 3)' },
    { min: 90, max: 100, color: 'rgb(212, 1, 1)' },
    { min: 100, max: 110, color: 'rgb(255, 106, 218)' },
  ],
  mtDewPoint: [
    { min: 0, max: 10, color: '#a3a197ff' },
    { min: 10, max: 20, color: '#baccbbff' },
    { min: 20, max: 30, color: 'rgb(181, 204, 143)' },
    { min: 30, max: 40, color: '#98b46cff' },
    { min: 40, max: 50, color: '#73a05eff' },
    { min: 50, max: 60, color: '#33a535ff' },
    { min: 60, max: 70, color: 'rgb(51, 165, 85)' },
    { min: 70, max: 80, color: 'rgb(36, 204, 112)' },
    { min: 80, max: 90, color: 'rgb(7, 146, 88)' },
    { min: 90, max: 100, color: 'rgb(1, 88, 76)' },

  ],
  sawti: [
    { min: 0, max: 10, color: '#88bcda' },
    { min: 10, max: 20, color: '#ffd17b' },
    { min: 20, max: 30, color: '#ff9249' },
    { min: 30, max: 40, color: '#f34e02' },
    { min: 40, max: 50, color: '#ff4040' },
    { min: 50, max: 100, color: '#c70053' },
  ],

  kbdi: [
    { min: 0, max: 100, color: '#239441' },
    { min: 100, max: 200, color: '#43cc68' },
    { min: 200, max: 300, color: '#c4ed98' },
    { min: 300, max: 400, color: '#f4f78b' },
    { min: 400, max: 500, color: '#edc25c' },
    { min: 500, max: 600, color: '#f2b72c' },
    { min: 600, max: 700, color: '#f2352e' },
    { min: 700, max: 750, color: '#eb575c' },
    { min: 750, max: 800, color: '#ed2f95' },
  ],

  ignition_component: [
    { min: 0, max: 9, color: '#239441' },
    { min: 9, max: 24, color: '#43cc68' },
    { min: 24, max: 37, color: '#c4ed98' },
    { min: 37, max: 49, color: '#f4f78b' },
    { min: 49, max: 62, color: '#edc25c' },
    { min: 62, max: 74, color: '#f2b72c' },
    { min: 74, max: 89, color: '#f2352e' },
    { min: 89, max: 100, color: '#eb575c' },
    { min: 100, max: 110, color: '#ed2f95' },
  ],

  spread_component: [
    { min: 0, max: 10, color: '#239441' },
    { min: 10, max: 20, color: '#43cc68' },
    { min: 20, max: 30, color: '#c4ed98' },
    { min: 30, max: 40, color: '#f4f78b' },
    { min: 40, max: 80, color: '#edc25c' },
    { min: 80, max: 120, color: '#f2b72c' },
    { min: 120, max: 200, color: '#f2352e' },
  ],

  energy_release_component: [
    { min: 0, max: 5, color: '#239441' },
    { min: 5, max: 15, color: '#43cc68' },
    { min: 15, max: 20, color: '#c4ed98' },
    { min: 20, max: 30, color: '#f4f78b' },
    { min: 30, max: 40, color: '#edc25c' },
    { min: 40, max: 50, color: '#f2b72c' },
    { min: 50, max: 60, color: '#f2352e' },
  ],

  burning_index: [
    { min: 0, max: 10, color: '#239441' },
    { min: 10, max: 20, color: '#43cc68' },
    { min: 20, max: 30, color: '#c4ed98' },
    { min: 30, max: 40, color: '#f4f78b' },
    { min: 40, max: 60, color: '#edc25c' },
    { min: 60, max: 80, color: '#f2b72c' },
    { min: 80, max: 100, color: '#f2352e' },
    { min: 100, max: 120, color: '#eb575c' },
  ],

  tenhrfm: [
    { min: 0, max: 2, color: '#6e420c' },
    { min: 2, max: 4, color: '#a30505' },
    { min: 4, max: 6, color: '#f50202' },
    { min: 6, max: 10, color: '#e8640c' },
    { min: 10, max: 15, color: '#dbc753' },
    { min: 15, max: 30, color: '#6dcc39' },
    { min: 30, max: 45, color: '#11bf31' },
    { min: 45, max: 60, color: '#08d187' },
  ],

  hunhrfm: [
    { min: 0, max: 2, color: '#6e420c' },
    { min: 2, max: 4, color: '#a30505' },
    { min: 4, max: 6, color: '#f50202' },
    { min: 6, max: 10, color: '#e8640c' },
    { min: 10, max: 15, color: '#dbc753' },
    { min: 15, max: 30, color: '#6dcc39' },
    { min: 30, max: 45, color: '#11bf31' },
    { min: 45, max: 60, color: '#08d187' },
  ],

  thhrfm: [
    { min: 0, max: 2, color: '#6e420c' },
    { min: 2, max: 4, color: '#a30505' },
    { min: 4, max: 6, color: '#f50202' },
    { min: 6, max: 10, color: '#e8640c' },
    { min: 10, max: 15, color: '#dbc753' },
    { min: 15, max: 20, color: '#6dcc39' },
    { min: 20, max: 30, color: '#11bf31' },
    { min: 30, max: 40, color: '#08d187' },
  ],
};

export const getColorForValue = (variable, value) => {
  const ranges = colorMapping[variable];
  if (!ranges || value == null || isNaN(value)) return '#a5a5a5ff';

  for (const range of ranges) {
    if (value >= range.min && value < range.max) return range.color;
  }
  return ranges[ranges.length - 1].color; // fallback to max color
};

export default colorMapping;
